import classNames from 'classnames';
import * as React from 'react';
import type { TextOrComponent } from '~/Features/Types/TextOrComponent';
import { HtmlDiv } from '~/Partials/Controls/HtmlDiv';
import { asHtmlString } from '~/Partials/Controls/Utils/asHtmlString';
import styles from './ApplicationError.module.css';

export interface ApplicationErrorProps {
    body: TextOrComponent;
    heading?: string;
    className?: string;
}

export const ApplicationError: React.FC<React.PropsWithChildren<ApplicationErrorProps>> = React.memo(props => {
    const { heading, body, className } = props;

    return (
        <div className={classNames(styles.ApplicationError, !heading && styles['Variant--withoutHeading'], className)}>
            {heading && <p className={styles.Heading}>{heading}</p>}
            {body && typeof body === 'string' ? (
                <HtmlDiv html={asHtmlString(body)} className={styles.Body} />
            ) : (
                <span className={styles.Body}>{body}</span>
            )}
        </div>
    );
});
